<template>
  <div class="overlay">
    <div class="overlay-content">
      <a href="" @click="back" class="overlay-close">✕</a>
      <div class="overlay-inner">
        <div class="cleanmap">
          <h2>Cleantech Startup Map</h2>
          <p>The Cleantech Startup Map will soon be available.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  module.exports = {
    methods: {
      back () {
        window.history.go(-1)
      }}
  }
</script>



// WEBPACK FOOTER //
// Map.vue?309bfa98